

const createReducer = (state, action, handlers) => {

  const { type, payload } = action;
  const actionHandler = handlers[type];

  if (actionHandler) { return actionHandler(state, payload); }

  return state;
}

export default createReducer;